import React, { useState } from 'react';
import { Platform, TextInput, View } from 'react-native';
import { IconButton } from '..';
import { useStyleSheet, useThemeContext } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Icon } from '../Icon';
import { Text } from '../Text';
export function Input({ action, autoCorrect, autoFocus, disabled, error, fluid, hideDismiss, icon, inputStyle, numberOfLines, label, onChange, onEnter, onFocus, onBlur, placeholder, placeholderTextColor, secureTextEntry, style, value, textContentType, defaultValue }) {
    const { color } = useThemeContext();
    const [focused, setFocused] = useState(false);
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, fluid ? styles.fluid : {}, style] },
        label ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.label }, label)) : null,
        React.createElement(View, { style: disabled ? styles.disabled : {} },
            icon ? (React.createElement(View, { style: styles.icon },
                React.createElement(Icon, { name: icon, size: 21, color: color.invert2.p84 }))) : null,
            React.createElement(TextInput, Object.assign({ style: [
                    styles.input,
                    focused ? styles.focused : {},
                    !hideDismiss || action ? styles.withRightPadding : {},
                    icon ? styles.withLeftPadding : {},
                    inputStyle,
                    (Platform.OS === 'web' ? { outline: 'none' } : {})
                ] }, (numberOfLines ? { numberOfLines, multiline: true } : {}), { onSubmitEditing: onEnter, editable: !disabled, blurOnSubmit: true, value: value, onChangeText: onChange, placeholderTextColor: placeholderTextColor !== null && placeholderTextColor !== void 0 ? placeholderTextColor : color.invert2.p56, autoCorrect: autoCorrect !== null && autoCorrect !== void 0 ? autoCorrect : true, autoFocus: autoFocus, placeholder: placeholder, secureTextEntry: secureTextEntry, textContentType: textContentType, defaultValue: defaultValue, onFocus: () => {
                    setFocused(true);
                    if (onFocus)
                        onFocus();
                }, onBlur: () => {
                    setFocused(false);
                    if (onBlur)
                        onBlur();
                } })),
            React.createElement(View, { style: [
                    styles.action,
                    numberOfLines ? styles.multilineAction : styles.oneLineAction
                ] }, action ? (action) : value ? (hideDismiss || disabled ? null : (React.createElement(IconButton, { value: 'dismiss', type: 'tertiary', accent: 'neutral', onPress: () => {
                    onChange('');
                }, size: 'xs' }))) : null)),
        error ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.error }, error)) : null));
}
/**
 * height 53 / 26.5
 *
 * icon 21/ 10.5
 */
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {},
    fluid: { flex: 1, width: '100%' },
    disabled: { opacity: 0.56 },
    label: { marginBottom: size.C },
    icon: {
        position: 'absolute',
        width: size.I,
        height: size.I,
        left: size.F,
        top: size.F + 1,
        bottom: 0
    },
    action: {
        position: 'absolute',
        right: size.C,
        height: size.I + size.C * 2
    },
    oneLineAction: {
        top: size.F + 1 - size.C
    },
    multilineAction: {
        bottom: size.C
    },
    input: {
        padding: size.F,
        borderWidth: 1,
        borderColor: color.invert2.p4,
        borderRadius: size.C,
        lineHeight: size.I,
        color: color.invert2.p100,
        fontSize: size.G,
        fontWeight: '400'
    },
    withRightPadding: {
        paddingRight: size.I + size.C * 2 + size.C * 2
    },
    withLeftPadding: {
        paddingLeft: size.F + size.I + size.C
    },
    focused: {
        borderColor: color.invert2.p16
    },
    error: {
        color: color.negative.solid,
        marginTop: size.C,
        textAlign: 'center'
    }
}));
//# sourceMappingURL=index.js.map